import MultipleOfferTemplate from '../../component/template/MultipleOfferTemplate'
import Webview from '../../component/native/visible/Webview'
import Message from '../../Message'

export default class VideoSwitchableTemplate extends MultipleOfferTemplate {
  constructor(props = {}) {
    super(props)
    this.currentOffer = this.campaignList[0]
  }

  show() {
    super.show()
  }

  initComponents() {
    super.initComponents()
    this.endcard = new Webview()

    this.campaignList.forEach(campaign=>{
      const subTpl = new Webview()
      let subTplURL = campaign && campaign.rv && campaign.rv.template_url

      Webview.getLoadCampaignParams(subTplURL, [campaign], this.unit.id, this.unit.setting)
      .then(loadParams=>{
        console.log('获取到load campaign参数：', loadParams)
        subTpl.load(loadParams)
      })

      campaign.getTemplate = () => {
        return subTpl
      }
    })

    this.nextOfferChoice = new Webview()
    Webview.getLoadCampaignParams('http://192.168.6.82:3000/simple-banner/simple-banner.html', [this.campaignList[1]], this.unit.id, this.unit.setting)
    .then(loadParams=>{
        console.log('获取到load campaign参数(跳转用banner)：', loadParams)
        this.nextOfferChoice.load(loadParams)
    })
  }

  bindPageEvent() {
    Message.onEmitMessage('onCloseBtnClick', (data) => {
      if (data.instanceId == this.endcard.getId()) {
        this.destory()
      }

      if (data.instanceId == this.currentOffer.getTemplate().getId()) {
        const ecOffer = data.campaign
        Webview.getLoadCampaignParams(ecOffer.endcard_url, [ecOffer], this.unit.id, this.unit.setting)
        .then(loadParams => {
            console.log('获取到load campaign参数(跳转用banner)：', loadParams)
            this.endcard.load(loadParams)
            this.slotOut('slot_1', this.currentOffer.getTemplate())
            this.slotOut('slot_2', this.nextOfferChoice)
            this.slotIn('slot_1', this.endcard)
        })
      }

      if (data.instanceId == this.nextOfferChoice.getId()) {
        this.slotOut('slot_2', this.nextOfferChoice)
      }
    })

    Message.onEmitMessage('onVideoCurrentTimeChange', (data) => {
      if (parseInt(data.currentTime, 10) >= 5) {
        this.slotOut('slot_2', this.nextOfferChoice)
      }
    })

    Message.onEmitMessage('onInstallBtnClick', (data) => {
      if (data.instanceId == this.endcard.getId()) {
        // Todo
      }

      if (data.instanceId == this.currentOffer.getTemplate().getId()) {
        // Todo
      }

      if (data.instanceId == this.nextOfferChoice.getId()) {
        const nextOffer = this.campaignList[this.campaignList.indexOf(this.currentOffer)+1] || this.campaignList[0]
        const subTpl = nextOffer.getTemplate()
        this.currentOffer.getTemplate().removeSelf()
        this.slotIn('slot_1', subTpl)
        this.slotOut('slot_2', this.nextOfferChoice)
        console.log('change into next offer ====')
        this.currentOffer = nextOffer
      }
    })

    Message.onEmitMessage('onVideoEnded', (data) => {
      const ecOffer = data.campaign
      Webview.getLoadCampaignParams(ecOffer.endcard_url, [ecOffer], this.unit.id, this.unit.setting)
      .then(loadParams => {
          console.log('获取到load campaign参数(跳转用banner)：', loadParams)
          this.endcard.load(loadParams)
          this.slotOut('slot_1', this.currentOffer.getTemplate())
          this.slotIn('slot_1', this.endcard)
      })
    })
  }

  /**
   * 初始化插槽
   */
  initSlots(){
      super.initSlots()
      this.slotIn('slot_1', this.currentOffer.getTemplate())
      this.slotIn('slot_2', this.nextOfferChoice)
  }

  /**
   * 销毁组件
   */
  destory() {
      super.destory()
      this.currentOffer.getTemplate() && this.currentOffer.getTemplate().destory()
      this.nextOfferChoice && this.nextOfferChoice.destroy()
      this.endcard && this.endcard.destory()
  }

  /**
   * 子类需要重写该方法，以判断模板的是否成功加载
   * @returns {Promise}
   */
  _isLoadFinish(){
    return Promise.all([
      super._isLoadFinish(),
      this.currentOffer.getTemplate().whenCampaignReady(),
      this.nextOfferChoice.whenCampaignReady(),
    ])
  }
}